/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsListCatalogOrgAccess } from "../../funcs/llmModelsListCatalogOrgAccess.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListModelCatalogOrgAccessRequest$inboundSchema,
};

export const tool$llmModelsListCatalogOrgAccess: ToolDefinition<typeof args> = {
  name: "llm-models-list-catalog-org-access",
  description: `List an organization's cluster model access

Cluster operator view of an org's available cluster catalog entries and their activation state.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmModelsListCatalogOrgAccess(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
